import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index.js';
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};
/* Layout */

/* Router Modules */
// import componentsRouter from './modules/components'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
const constantRoutes = [
    {
        name: 'homePage',
        path: '/',
        component: () => import('@/views/pc/index'),
        meta: {
            as: '/mb/index',
            type: 'large'
        }
    },
    {
        name: 'walk-into',
        path: '/walk-into',
        component: () => import('@/views/pc/walk-into'),
        props: true,
        meta: {
            as: '/mb/walk-into',
            type: 'large'
        }
    },
    {
        name: 'culture',
        path: '/culture',
        component: () => import('@/views/pc/culture'),
        props: true,
        meta: {
            as: '/mb/culture',
            type: 'large'
        }
    },
    {
        name: 'appoint',
        path: '/appoint',
        component: () => import('@/views/pc/appoint'),
        props: true,
        meta: {
            as: '/mb/appoint',
            type: 'large'
        }
    },
    {
        name: 'service',
        path: '/service',
        component: () => import('@/views/pc/service'),
        props: true,
        meta: {
            as: '/mb/service',
            type: 'large'
        }
    },
    {
        name: 'information',
        path: '/information',
        component: () => import('@/views/pc/information'),
        props: true,
        meta: {
            as: '/mb/information',
            type: 'large'
        }
    },
    // ----------------------------------------------------------------------------------------------
    {
        name: 'mini-homePage',
        path: '/mb/index',
        component: () => import('@/views/mb/index'),
        props: true,
        meta: {
            as: '/',
            type: 'mini'
        }
    },
    {
        name: 'mini-walk-into',
        path: '/mb/walk-into',
        component: () => import('@/views/mb/walk-into'),
        props: true,
        meta: {
            as: '/walk-into',
            type: 'mini'
        }
    },
    {
        name: 'spot-detail',
        path: '/mb/spot-detail',
        component: () => import('@/views/mb/spot-detail'),
        props: true,
        meta: {
            as: '/index',
            type: 'mini'
        }
    },
    {
        name: 'video-detail',
        path: '/mb/video-detail',
        component: () => import('@/views/mb/video-detail'),
        props: true,
        meta: {
            as: '/index',
            type: 'mini'
        }
    },
    {
        name: 'mini-culture',
        path: '/mb/culture',
        component: () => import('@/views/mb/culture'),
        props: true,
        meta: {
            as: '/culture',
            type: 'mini'
        }
    },
    {
        name: 'mini-appoint',
        path: '/mb/appoint',
        component: () => import('@/views/mb/appoint'),
        props: true,
        meta: {
            as: '/appoint',
            type: 'mini'
        }
    },
    {
        name: 'mini-appoint-detail',
        path: '/mb/appoint-detail',
        component: () => import('@/views/mb/appoint-detail'),
        props: true,
        meta: {
            as: '/index',
            type: 'mini'
        }
    },
    {
        name: 'mini-service',
        path: '/mb/service',
        component: () => import('@/views/mb/service'),
        props: true,
        meta: {
            as: '/service',
            type: 'mini'
        }
    },
    {
        name: 'mini-service-detail',
        path: '/mb/service-detail',
        component: () => import('@/views/mb/service-detail'),
        props: true,
        meta: {
            as: '/index',
            type: 'mini'
        }
    },
    {
        name: 'mini-information',
        path: '/mb/information',
        component: () => import('@/views/mb/information'),
        props: true,
        meta: {
            as: '/information',
            type: 'mini'
        }
    },
    {
        name: 'mini-information-detail',
        path: '/mb/information-detail',
        component: () => import('@/views/mb/information-detail'),
        props: true,
        meta: {
            as: '/index',
            type: 'mini'
        }
    },
    {
        path: '/mb/video-player',
        component: () => import('@/views/mb/video-player'),
        meta: {
            as: '/index',
            type: 'mini'
        }
    },
    {
        path: '/mb/vr',
        component: () => import('@/views/mb/vr'),
        meta: {
            as: '/index',
            type: 'mini'
        }
    },
    {
        path: '/mb/map',
        component: () => import('@/views/mb/map'),
        meta: {
            as: '/index',
            type: 'mini'
        }
    },
    // ----------------------------------------------------------------------------------------------
    // 公共页面
    {
        path: '/test',
        component: () => import('@/views/test')
    }
];

const router = new Router({
    routes: constantRoutes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                x: 0,
                y: 0,
                selector: to.hash,
                behavior: 'smooth'
            };
        }
        if (savedPosition) {
            return savedPosition;
        }
        return { x: 0, y: 0 };
    }
});

var os = (function() {
    var ua = navigator.userAgent;
    var isWindowsPhone = /(?:Windows Phone)/.test(ua);
    var isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
    var isAndroid = /(?:Android)/.test(ua);
    var isFireFox = /(?:Firefox)/.test(ua);
    // eslint-disable-next-line no-unused-vars
    var isChrome = /(?:Chrome|CriOS)/.test(ua);
    var isTablet =
        /(?:iPad|PlayBook)/.test(ua) ||
        (isAndroid && !/(?:Mobile)/.test(ua)) ||
        (isFireFox && /(?:Tablet)/.test(ua));
    var isPhone = /(?:iPhone)/.test(ua) && !isTablet;
    var isPc = !isPhone && !isAndroid && !isSymbian;
    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
    };
})();
router.beforeEach((to, from, next) => {
    if (!to.meta.type) {
        next();
        return;
    }
    store.commit('setRouterType', to.meta.type);
    if (os.isPc) {
        if (to.meta.type === 'large') {
            next();
        } else {
            next(to.meta.as);
        }
    }
    if (os.isAndroid || os.isPhone) {
        if (to.meta.type === 'mini') {
            next();
        } else {
            next(to.meta.as);
        }
    }
    next();
});

export default router;
